(() => {
  'use strict';

  const MANUAL_KEY = 'peregy-language-manual-v3';
  const AUTO_KEY = 'peregy-language-auto-v3';
  const normalizeLanguage = (value) => String(value || '').trim().toLowerCase();
  const normalizeCountry = (value) => String(value || '').trim().toUpperCase();

  function languageRoot(language) {
    return normalizeLanguage(language).split('-')[0];
  }

  function languageFlag(language) {
    const root = languageRoot(language);
    if (root === 'ar') return '🇪🇬';
    if (root === 'en') return '🇬🇧';
    return '🌐';
  }

  function normalizeRoot(root) {
    try {
      const pathname = new URL(root || '/', window.location.origin).pathname || '/';
      return pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';
    } catch (error) {
      return '/';
    }
  }

  function updateVisual(form, language) {
    const flag = form.querySelector('[data-peregy-language-flag]');
    const code = form.querySelector('[data-peregy-language-code]');
    if (flag) flag.textContent = languageFlag(language);
    if (code) code.textContent = languageRoot(language).toUpperCase();
  }

  function hasManualPreference() {
    try {
      return localStorage.getItem(MANUAL_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function rememberManualPreference() {
    try {
      localStorage.setItem(MANUAL_KEY, 'true');
    } catch (error) {
      return;
    }
  }

  function buildReturnTo(form, option, language) {
    try {
      const url = new URL(window.location.href);
      const data = form.querySelector('[data-peregy-localization-data]');
      const currentRoot = normalizeRoot(data?.dataset.currentRoot || '/');
      let targetRoot = normalizeRoot(option?.dataset.peregyLanguageRoot || '/');
      const currentLanguage = normalizeLanguage(data?.dataset.currentLanguage);

      url.searchParams.delete('locale');

      if (targetRoot === currentRoot && language !== currentLanguage) {
        targetRoot = option?.dataset.peregyLanguagePrimary === 'true' ? '/' : `/${languageRoot(language)}`;
      }

      let relativePath = url.pathname || '/';
      if (currentRoot !== '/') {
        if (relativePath === currentRoot) {
          relativePath = '/';
        } else if (relativePath.startsWith(`${currentRoot}/`)) {
          relativePath = relativePath.slice(currentRoot.length) || '/';
        }
      }

      if (!relativePath.startsWith('/')) relativePath = `/${relativePath}`;
      url.pathname = targetRoot === '/' ? relativePath : `${targetRoot}${relativePath === '/' ? '' : relativePath}`;
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return window.location.pathname + window.location.search + window.location.hash;
    }
  }

  function submitLanguage(form, option, language, manual) {
    const languageInput = form.querySelector('[data-peregy-language-input]');
    const returnToInput = form.querySelector('[data-peregy-language-return-to]');
    if (!(languageInput instanceof HTMLInputElement)) return;

    languageInput.value = language;
    if (returnToInput instanceof HTMLInputElement) {
      returnToInput.value = buildReturnTo(form, option, language);
    }
    if (manual) rememberManualPreference();
    updateVisual(form, language);
    form.submit();
  }

  function applyMarketDefault(form) {
    const data = form.querySelector('[data-peregy-localization-data]');
    if (!(data instanceof HTMLElement) || data.dataset.autoDetect !== 'true' || hasManualPreference()) return;

    const currentCountry = normalizeCountry(data.dataset.currentCountry);
    const currentLanguage = normalizeLanguage(data.dataset.currentLanguage);
    const desiredRoot = currentCountry === 'EG' ? 'ar' : 'en';
    if (languageRoot(currentLanguage) === desiredRoot) return;

    const option = Array.from(form.querySelectorAll('[data-peregy-language-option]')).find(
      (item) => languageRoot(item.dataset.peregyLanguageOption) === desiredRoot
    );
    if (!option) return;

    const signature = `${currentCountry}:${desiredRoot}`;
    try {
      if (sessionStorage.getItem(AUTO_KEY) === signature) return;
      sessionStorage.setItem(AUTO_KEY, signature);
    } catch (error) {
      updateVisual(form, currentLanguage);
    }

    submitLanguage(form, option, normalizeLanguage(option.dataset.peregyLanguageOption), false);
  }

  function init(form) {
    if (!(form instanceof HTMLFormElement) || form.dataset.peregyLocalizationReady === 'true') return;
    form.dataset.peregyLocalizationReady = 'true';

    const languageInput = form.querySelector('[data-peregy-language-input]');
    if (!(languageInput instanceof HTMLInputElement)) return;
    updateVisual(form, languageInput.value);

    form.querySelectorAll('[data-peregy-language-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const language = normalizeLanguage(button.dataset.peregyLanguageOption);
        const details = button.closest('details');
        if (details) details.open = false;
        if (!language || language === normalizeLanguage(languageInput.value)) return;
        submitLanguage(form, button, language, true);
      });
    });

    applyMarketDefault(form);
  }

  const initAll = (root = document) => root.querySelectorAll('form.peregy-language-form').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
